













import Vue from "vue";
import Component from "vue-class-component";
import * as CONSTANTS from "@/common/constants";

@Component({})
export default class App extends Vue {
  name: "App";

  get LOADING_MODAL_ID() {
    return CONSTANTS.LOADING_MODAL_ID;
  }
}
